export default {
  placeholder: 'Introduceți numele restaurantului',
  labels: {
    cant_find_place: 'Nu găsiți locul în listă?',
    reset_categories: 'Resetați categoriile de locuri',
  },
};
